<template>
    <div class="rate-card-actions-cell">
        <template v-if="isEditing">
            <icon-button icon="custom:cancel" size="small" @click.stop="cancelRateCard" />
        </template>
        <template v-else>
            <icon-button icon="custom:edit" size="small" @click.stop="editRateCard" />
        </template>
        <rate-card-delete-dialog
            :resource="rateCardsResource"
            :resource-id="resourceId"
            :child-dependencies-warning="false"
            @resource-deleted="handleDelete"
        />
    </div>
</template>

<script>
import { isFunction } from 'lodash';
import resources from '@enums/resources';

export default {
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rateCardsResource: resources.rateCards,
        };
    },
    computed: {
        resourceId() {
            return this.params.data._id;
        },
        isEditing() {
            return this.params.isEditing(this.resourceId);
        },
    },
    methods: {
        editRateCard() {
            if (isFunction(this.params.onEdit)) {
                this.params.onEdit(this.params.data);
            }
        },
        cancelRateCard() {
            if (isFunction(this.params.onCancel)) {
                this.params.onCancel(this.params.data);
            }
        },
        handleDelete() {
            if (isFunction(this.params.onDeleted)) {
                this.params.onDeleted(this.params.data);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.rate-card-actions-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    width: 100%;
    height: 100%;
}
</style>
